export class LatLong {
    id: number;
    location: string;
    country: string;
    lattitude: string;
    longitude: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/latLong.ts